export const CyPlaylistBanner = {
  PlaylistBanner: "PlaylistBanner",
  PlaylistBannerItem: "PlaylistBannerItem",
} as const;
